import {Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation} from '@angular/core';

// Строка другого склада партнёра под строкой товара (раскрывается подсказкой app-partner-wh-hint).
// Колонки повторяют строку товара в каталоге/карточке/аналогах, чтобы таблица не ехала.
// Кнопка «в кошик» отдаёт родителю копию строки поставщика с остатком и датой этого склада и sup_wh_id —
// родитель кладёт в корзину своим addToBasket/addToBasketMobile (модалка невозвратных товаров и т.п. — как у обычной строки).
// Стили без инкапсуляции: ячейки живут внутри таблицы родителя, его scoped-правила сюда не достают.
@Component({
  selector: 'tr[appPartnerWhRow]',
  templateUrl: './partner-wh-row.component.html',
  styleUrls: ['./partner-wh-row.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PartnerWhRowComponent {
  @HostBinding('class.partner-wh-row') hostClass = true;

  @Input() good: any;
  @Input() sup: any;
  @Input() wh: any;
  @Input() userSupper: number;
  @Input() isAdmin: boolean;
  @Input() roleId: number;
  @Input() currencyName: string;

  @Output() add = new EventEmitter<any>();
  @Output() addMobile = new EventEmitter<any>();

  // Копия строки поставщика с данными этого склада — то, что ждут addToBasket/addToBasketMobile родителя
  private whSup() {
    return {
      ...this.sup,
      count: this.wh.count,
      expire: this.wh.expire,
      countBasket: this.wh.countBasket,
      whName: this.wh.name,
      sup_wh_id: this.wh.id,
      others: [],
      whExpanded: false,
    };
  }

  minusCount() {
    const count = parseInt(this.wh.countBasket) - 1;
    this.wh.countBasket = isNaN(count) || count < 1 ? 1 : count;
  }

  plusCount() {
    const count = parseInt(this.wh.countBasket) + 1;
    this.wh.countBasket = isNaN(count) ? 1 : count;
  }

  addToBasket() {
    this.add.emit(this.whSup());
    this.wh.countBasket = 1;
  }

  addToBasketMobile() {
    this.addMobile.emit(this.whSup());
  }
}
